import {ReactCompareSlider, ReactCompareSliderImage} from 'react-compare-slider'

import {twMerge} from '@sdox/utils'

import {Handle} from './Handle'

import type {ComponentProps} from 'react'

export interface ComparisonSliderProps extends ComponentProps<'div'> {
  /** 2 images src to compare [XC]*/
  images?: string[]
}

/**
 * ComparisonSlider component
 * simple slider compare view for 2 images
 */
export const ComparisonSlider = ({images = [], className, ...restProps}: ComparisonSliderProps) => (
  <div
    className={twMerge(
      'w-full overflow-hidden @container/block',
      'no-pullout-rounded-md pullout-rounded-lg',
      className,
    )}
    {...restProps}
  >
    <ReactCompareSlider
      handle={<Handle />}
      itemOne={(
        <ReactCompareSliderImage
          src={images[0]}
          alt={'compare-1'}
          loading={'lazy'}
          className={'bg-media-bg'}
        />
      )}
      itemTwo={(
        <ReactCompareSliderImage
          src={images[1]}
          alt={'compare-2'}
          loading={'lazy'}
          className={'bg-media-bg'}
        />
      )}
    />
  </div>
)
